// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"73365b83","123":"0077b08b","478":"0b66f40b","703":"6d0016cc"}[chunkId] + ".chunk.js";
};